<template>
  <AppNotification
    :title="notification.title"
    :description="description"
    :level="level"
    :detailUrl="detailUrl"
    @close="close"
  />
</template>

<script lang="ts">
import { computed, defineComponent, PropType, SetupContext } from 'vue'

import AppNotification, { PropLevelType } from '@/client/components/_atoms/app_notification'
import { EmergencyNotificationResponse } from '@/typings/emergency_notifications'

export default defineComponent({
  name: 'GlobalAppNotification',
  components: {
    AppNotification
  },
  emits: ['close'],
  props: {
    notification: {
      type: Object as PropType<EmergencyNotificationResponse>,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const level = computed<PropLevelType>(() => (props.notification.type === 0 ? 'danger' : 'info'))
    const description = computed(() => props.notification.description ?? '')
    // XSS対策. TODO: URL正規化を共通化する.
    const detailUrl = computed(() => {
      const url = props.notification.detail_url ?? ''

      return /^https?:\/\//.test(url) ? url : ''
    })

    const close = () => context.emit('close')

    return {
      level,
      description,
      detailUrl,
      close
    }
  }
})
</script>
